export interface GetBookbindingCollectionRequest {
  collectionId: number
  collectionNo: string
}

export function GetBookbindingCollectionRequestToJSON(
  value: GetBookbindingCollectionRequest
): any {
  return {
    collection_id: value.collectionId !== 0 ? value.collectionId : undefined,
    collection_no: value.collectionNo !== '' ? value.collectionNo : undefined
  }
}
